import React, { Component } from 'react';
import { Field } from 'redux-form';
import { LongTextInput, NumberInput, TextField, TextInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import ConfirmDeleteIcon from '../../../../Common/Buttons/ConfirmDeleteIcon';
import CreateItem from '../../../../Common/Partials/CreateItem';
import isBlank from '../../../../Common/Utils/Blank';
import isPresent from '../../../../Common/Utils/Present';

const styles = createStyles({
  name: {
    width: 550
  },
  pace: {
    width: 80
  },
  value: {
    width: 550,
    fontFamily: 'monospace'
  }
});

type Props = {
  classes: any,
  fields: any,
  record: any
};

class AdServerSettings extends Component<Props> {
  handleRemove = (e, index) => {
    this.props.fields.remove(index);
    this.props.record.settings.splice(index, 1);
  }

  render() {
    return (
      <div>
        {this.props.fields.length > 0 && this.props.fields.map((item, index) => (
          <div key={index}>
            <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', padding: 25 }}>
              <FormDataConsumer>
                {({ formData, ...rest }) => isPresent(this.props.record.settings) && isPresent(this.props.record.settings[index]) && this.props.record.settings[index].experimental &&
                  <div>
                    Name <TextField source={`${item}.name`} record={this.props.record} /><br />
                    Value <TextField source={`${item}.value`} record={this.props.record} /><br />
                    Pace % <TextField source={`${item}.pace`} record={this.props.record} />
                  </div>
                }
              </FormDataConsumer>

              <FormDataConsumer>
                {({ formData, ...rest }) => (isBlank(this.props.record.settings) || isBlank(this.props.record.settings[index]) || isBlank(this.props.record.settings[index].experimental)) &&
                  <div>
                    <Field name={`${item}.name`} source={`${item}.name`} component={TextInput} label="Name" className={this.props.classes.name} /><br />
                    <Field name={`${item}.value`} source={`${item}.value`} component={LongTextInput} label="Value" options={{ rowsMax: 30 }} className={this.props.classes.value} /><br />
                    <Field name={`${item}.pace`} source={`${item}.pace`} component={NumberInput} label="Pace %" className={this.props.classes.pace} />

                    <div style={{ display: 'inline' }}>
                      <ConfirmDeleteIcon onClick={(event) => this.handleRemove(event, index)} />
                    </div>
                  </div>
                }
              </FormDataConsumer>
            </div><br />
          </div>
        ))}
        <div style={{ float: 'right', padding: '20px 80px 0 0 ' }}>
          <CreateItem fields={this.props.fields} label="Add Server Setting" />
        </div>
      </div>
    )
  }
};

export default withStyles(styles)(AdServerSettings);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/AdServerSettings.tsx